
import {take} from 'rxjs/operators';
/**
 * Created by christiancueni on 02/08/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */
import { Component } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { Observable } from "rxjs";
import * as reducer from "../../reducers";
import { AddAlertAction, RemoveAlertAction } from "../../alerts/alerts.actions";
import { PasswordResetAction } from "../../actions/authentication";


@Component({
    selector: 'hc-password-reset-page',
    template: `
    <div class="container-fluid">
        <div class="row vertical-margin">
            <div class="col-md-4 col-md-offset-3">
                <hc-alert></hc-alert>
            </div>
        </div>
        <hc-password-reset (submitForm)="reset($event)"></hc-password-reset>
    </div>
    `
})
export class PasswordResetPage {
    anonymous$: Observable<any>;
    logginIn$: Observable<any>;

    constructor(private store: Store<reducer.AppState>,
                private router: Router,
                private activatedRoute: ActivatedRoute) {
        /**
         * Selectors can be applied with the `let` operator, which passes the source
         * observable to the provided function. This allows us an expressive,
         * composable technique for creating view projections.
         *
         * More on `let`: https://gist.github.com/btroncone/d6cf141d6f2c00dc6b35#let
         * More on selectors: https://gist.github.com/btroncone/a6e4347326749f938510#extracting-selectors-for-reuse
         */
        this.anonymous$ = store.select(reducer.getAuthUser).pipe(take(1));
        this.logginIn$ = store.select(reducer.getAuthLogginIn);

        this.activatedRoute.params
            .subscribe(params => {
                let message = params[ 'message' ];
                if (message && message !== '') {
                    this.store.dispatch(new AddAlertAction({ message: message, type: 'fail' }));
                }
            });
    }

    reset(passwordNew: Object) {
        this.store.dispatch(new PasswordResetAction(passwordNew));
    }

    dismissAlert() {
        this.store.dispatch(new RemoveAlertAction());
    }

}
